<template>
<div style="border-top:3px solid #aaa;padding-top:20px;">
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="88px" style="margin-right:100px;">
      <el-form-item label="Match">
        <el-select v-model="ruleForm.platform_order_name" placeholder="Order, 10023..." style="width:400px;" clearable allow-create @clear="clear_order" @change="switch_order">
          <el-option 
            v-for="item in orders_options" 
            :key="item.platform_order_name" 
            :label="'#' + item.platform_order_name + ' | ' + item.email + ' | ' + item.full_name" 
            :value="item.platform_order_name"></el-option>
        </el-select>
        <el-select v-model="ruleForm.template_id" placeholder="Select Template" style="width:646px;" clearable @clear="clear_template" @change="switch_template">
          <el-option v-for="item in templates_options" :key="item.id" :label="'[' + item.name + '] ' + item.subject" :value="item.id">
            <b>[{{item.name}}]</b>
            <span>{{ item.subject }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="From" prop="from_email">
        <el-select
            v-model="ruleForm.from_email"
            filterable
            default-first-option
            placeholder="Input email number, Enter <<<"
            style="width: 100%;"
          >
            <el-option
              v-for="email222 in [ruleForm.from_email]"
              :key="email222"
              :label="email222"
              :value="email222"
            />
          </el-select>
      </el-form-item>
      <el-form-item label="To" prop="to_emails">
        <el-select
            v-model="ruleForm.to_emails"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="Input email number, Enter <<<"
            style="width: 100%;"
          >
            <el-option
              v-for="item in customer_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
      </el-form-item>
      <el-form-item label="Subject" prop="subject">
        <el-input v-model="ruleForm.subject" placeholder="Subject.."></el-input>
      </el-form-item>
      <el-form-item label="Body" prop="html_content">
        <div>
          <editor-bar
            v-model="ruleForm.html_content"
            :isClear="isClearEditor"
            @change="changeContent"
            @add_attachment="add_attachment"
            @set_upload_loading="set_upload_loading"
            ref="editorRef"
          ></editor-bar>
          
          <div class="e-sender-file-doo2">
            <div v-loading="editor_upload_loading" v-if="editor_upload_loading" class="lodd2"></div>
            <ul class="clearfix">
              <li v-for="(f2, index_f2) in ruleForm.file_list" :key="index_f2" class="clearfix li022">
                <span>{{ f2.file_name }}</span>
                <i class="el-icon-close li-cxx2" @click="remove_file(index_f2)"></i>
              </li>
            </ul>
          </div>

          <!-- 客服动态指令 Prompt 输入框 -->
          <div class="relative">
            <el-input 
              v-model="ruleForm.solution_prompt" 
              placeholder="请输入 AI 提示词（例如：告知买家已免费重发，请她确认收货地址）..." 
              type="textarea" 
              :rows="solution_prompt_mode ? 10 : 1" 
              @focus="focus_solution_prompt" 
              @blur="blur_solution_prompt"
            ></el-input>
            
            <el-button 
              type="info" 
              size="small"
              @click="write_by_AI" 
              style="position: absolute; bottom: 8px; left: 8px;" 
              v-loading="loading_ai" 
              :disabled="loading_ai || !ruleForm.solution_prompt" 
              v-if="solution_prompt_mode"
            >
              AI 生成
            </el-button>
          </div>
        </div>
      </el-form-item>
  </el-form>  
  <div style="text-align: right;">
    <span v-if="ruleForm.mailbox_email" class="gray-color   ">By {{ ruleForm.mailbox_email }}</span>
    <el-button type="primary" @click="send('ruleForm')" style="margin-left:10px;margin-right: 99px;">发 送</el-button>
  </div>  
</div>
</template>
<script>
import EditorBar from "../public/_TinymceEditor";

export default {
  props: ["email_detail_id", "account", "email_message_type", "orders"],
  components: {
    EditorBar,
  },
  data(){
    return {
      token:localStorage.getItem("token"),
      isClearEditor: false,
      email_detail: null,
      fileList:[],
      editor_upload_loading:false,
      checked_order:null,
      loading:false,
      loading_ai:false,
      solution_prompt_mode:0,
      ruleForm: {
        platform_order_name:"",
        template_id: "",
        thread_id: "",
        reply_to_email_id:"",
        mailbox_email:"",
        customer_email:"",
        from_email: "",
        to_emails:[],
        subject:"",
        html_content: "",
        images_in_content:[],
        file_list:[],
        message_type:0,//场景类型，0:default; 1:reply; 2:return request; 3:logistics failed; 4.order request
        email_vars:null,
        solution_prompt:"",
      },
      rules: {
        from_email: [
            { required: true, message: '发件人人不能为空', trigger: 'change' },
        ],
        to_emails: [
            { required: true, message: '收件人不能为空', trigger: 'change' },
        ],
        subject: [
            { required: true, message: '标题不能为空', trigger: 'change' },
        ],
      },
      customer_options:[],
      email_template_options: [
        {value:'template_shipped', label:"template_shipped"},
        {value:'template_arrived', label:"template_arrived"},
      ],
      app_options: [],
      templates_options: [],
      orders_options:[],
    }
  },
  methods: {
    remove_file(index) {
      this.$confirm('删除附件', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          this.ruleForm.file_list = this.ruleForm.file_list.filter((_, i) => i !== index);
      }) 
    },
    get_app_options(){
      this.$http.post('/v1/pri/cfg-applets/options', {})
        .then( (response) => {
          var res = response.data;
          if (res.code == 1) {
              this.app_options = res.data.list
          }
        })            
    },
    focus_solution_prompt(){
      this.solution_prompt_mode = 1;
    },
    blur_solution_prompt(){
      if (!this.ruleForm.solution_prompt) {
        this.solution_prompt_mode = 0;
      }
    },
    clear_order(){},
    switch_order() { },
    changeContent(val) {
      this.ruleForm.html_content = val;
    },
    set_upload_loading(e){
      console.log('e------------------------3----------', e)
      this.editor_upload_loading = e;
    },
    add_attachment(e){
      this.ruleForm.file_list.push(e)
    },
    clear_template(){
      this.changeContent("")
    },
    switch_template() {
      if (!this.ruleForm.email_vars) {
        this.$message({
          message: "Order Not Found",
          type: "warning",
        });
        return;
      }

      // 1. 查找选中的模板内容
      const template = this.templates_options.find(
        (item) => item.id == this.ruleForm.template_id
      );
      let html_content = template ? template.html_content || "" : "";
      let subject = template ? template.subject || "" : "";

      // 2. 封装通用的变量替换函数
      const replaceVars = (text) => {
        if (!text) return text;
        let result = text;
        Object.keys(this.ruleForm.email_vars).forEach((key) => {
          const value = this.ruleForm.email_vars[key];
          if (value !== undefined && value !== null && value !== '') {
            const regex = new RegExp(`\\$\\{${key}\\}`, 'g');
            result = result.replace(regex, value);
          }
        });
        return result;
      };

      // 3. 同时对 subject 和 html_content 进行替换
      subject = replaceVars(subject);
      html_content = replaceVars(html_content);

      // 4. 检查 subject 和 html_content 中是否还残留未匹配到的 ${variable} 标签
      const fullTextToNotice = subject + " " + html_content;
      const missingVarsMatch = fullTextToNotice.match(/\$\{[a-zA-Z0-9_]+\}/g);
      if (missingVarsMatch && missingVarsMatch.length > 0) {
        const missingVars = [...new Set(missingVarsMatch)].join(', ');
        this.$message({
          message: `Warning: Variable(s) ${missingVars} have no value!`,
          type: "warning",
        });
      }

      // 5. 更新表单的主题与富文本内容
      this.ruleForm.subject = subject;
      this.changeContent(html_content);
    },
    get_templates_options() {
      this.$http
        .post("/v1/pri/store-email-templates/options", {type:0})
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.templates_options = res.data.list
          }
        })
    },
    get_templates_data(order_no) {
      this.$http
        .post("/v1/pri/store-email/email-var-data", {order_no:order_no})
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.ruleForm.email_vars = res.data
          }
        })
    },
    search_order() {
      if (!this.ruleForm.customer_email) {
        return;
      }
      var order_name = "";
      const regex = /#100[234]\d{4,9}\b/g;
      for (var i=0; i < this.email_detail.record.length; i++) {
        var str = this.email_detail.record[i].body_html + this.email_detail.record[i].body_text + this.email_detail.record[i].subject + this.email_detail.record[i].summary
        const matches = str.match(regex);
        if (matches) {
          order_name = matches[0];
          break;
        }
      }

      this.$http
        .post("/v1/pri/orders/match-orders-for-email", {order_name:order_name, email:this.ruleForm.customer_email, full_name:this.email_detail.customer.from_address_full_name})
        .then((response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            this.orders_options = res.data.list
            if ( res.data.list.length > 0 ) {
              this.ruleForm.platform_order_name = res.data.list[0].platform_order_name;
            }
          }
        })
    },
    get_email_detail() {
      if (!this.email_detail_id) return;
      this.$http
        .post("/v1/pri/store-email/messages-detail", {id:this.email_detail_id})
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.email_detail = res.data
            this.ruleForm.to_emails = [this.email_detail.customer.from_address_email];
            this.ruleForm.customer_email = this.email_detail.customer.from_address_email;
            this.ruleForm.thread_id = this.email_detail.message.thread_id;
            this.ruleForm.reply_to_email_id = this.email_detail.message.email_id;
            this.ruleForm.from_email = this.ruleForm.mailbox_email = this.email_detail.message.mailbox_email;
   
            const rawSubject = this.email_detail.message.subject || "";
            const hasRe = rawSubject.trim().toLowerCase().startsWith("re:");
            this.ruleForm.subject = hasRe ? rawSubject : `Re: ${rawSubject}`;

            this.search_order();
          }
        }).catch((err) => {
          console.log(err) 
          this.loading = false;
        })
    },
    write_by_AI(){
      this.loading_ai = true
      this.$http
        .post("/v1/pri/store-email/write-content-by-gemini", this.ruleForm)
        .then((response) => {
          this.loading_ai = false
          var res = response.data;
          if (res.code == 1) {
            this.ruleForm.subject = res.data.subject;
            this.ruleForm.html_content = res.data.content;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning',
              duration: 5000
            });
          }
        })
    },
    set_email_account() {
      var apps = this.$store.state.public.cfg.apps_options;
      for (var i=0; i<apps.length; i++) {
        if (this.orders && this.orders.app_id == apps[i].id) {
          this.ruleForm.from_email = this.ruleForm.mailbox_email = apps[i].email;
          break;
        }
      }
    },
    send(formName) {
      const imagesInContent = this.$refs.editorRef ? this.$refs.editorRef.getFileList() : [];
      this.ruleForm.images_in_content = imagesInContent;

      const cleanText = (this.ruleForm.html_content || "")
          .replace(/<[^>]+>/g, "")      // 剥离所有 HTML 标签
          .replace(/&nbsp;/ig, "")      // 剥离 &nbsp;
          .trim();                      // 清除首尾纯空格
      if (cleanText.length < 3) {
        this.$message({
          message: 'Email body cannot be empty!',
          type: 'warning',
          duration: 3000
        });
        return; // 阻断提交
      }
    

      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 1. 拦截校验：检查 subject 和 html_content 中是否残留未替换的 ${variable} 标签
          const fullTextToCheck = (this.ruleForm.subject || "") + " " + (this.ruleForm.html_content || "");
          const missingVarsMatch = fullTextToCheck.match(/\$\{[a-zA-Z0-9_]+\}/g);

          if (missingVarsMatch && missingVarsMatch.length > 0) {
            // 数组去重并格式化展示
            const missingVars = [...new Set(missingVarsMatch)].join(', ');
            this.$message({
              message: `发送失败：邮件中包含未替换的变量 ${missingVars}，请检查订单数据或修改模板！`,
              type: 'error',
              duration: 5000
            });
            // 直接 return 阻断后续发送流程
            return;
          }

          // 2. 校验通过，执行发送请求
          this.$store.commit('setLoading', { text: 'Sending..' });
          this.$http.post('/v1/pri/store-email/send-message', this.ruleForm)
            .then((response) => {
              this.$store.commit('setLoading', { text: false });
              var res = response.data;
              if (res.code == 1) {
                this.$message({
                  message: 'Send success',
                  type: 'success'
                });
                setTimeout(() => {
                  this.redirect('/email');
                }, 1500);
              } else {
                this.$message({
                  message: res.msg,
                  type: 'warning'
                });
              }
            })
            .catch((error) => {
              this.$store.commit('setLoading', { text: false });
            });
        }
      });
    },
  },
  mounted(){
    this.get_app_options()
    this.get_templates_options()
    if ( this.email_message_type ) {
      this.ruleForm.message_type = this.email_message_type;
    }
    if (this.orders) {
      this.ruleForm.platform_order_name = this.orders.platform_order_name;
      this.ruleForm.to_emails = [this.orders.email];
      this.checked_order = JSON.parse(JSON.stringify(this.orders));
      this.get_templates_data(this.orders.order_no);
    }
    setTimeout(() => {
      if (this.email_detail_id) {
        this.get_email_detail()
      }
      if (this.account) {
        this.ruleForm.from_email = this.ruleForm.mailbox_email = this.account.mailbox_email;
      }
      if (this.orders) {
        this.set_email_account();
      }
    }, 1000);
  },
}
</script>
<style>
.e-sender-file-doo2{margin-top: 10px;}
.e-sender-file-doo2 .lodd2{height: 50px;width: 100%;}
.e-sender-file-doo2 .li022{background-color: #dfdfdf;padding: 2px 5px;display: inline-block;float: left;position: relative;padding-right: 32px;margin-right: 10px;}
.e-sender-file-doo2 .li-cxx2{margin-left: 10px;position: absolute;top: 5px; right: 0;display: block;width: 32px;height: 32px;line-height: 32px;text-align: center;cursor: pointer;font-weight: bold;}
</style>


// WEBPACK FOOTER //
// src/pages/email/_sender.vue